'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = require('@hixme-ui/text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Currency = function Currency(_ref) {
  var children = _ref.children,
      defaultSymbol = _ref.defaultSymbol,
      hideCents = _ref.hideCents,
      hideCommas = _ref.hideCommas,
      noSymbol = _ref.noSymbol,
      round = _ref.round,
      value = _ref.value,
      props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'defaultSymbol', 'hideCents', 'hideCommas', 'noSymbol', 'round', 'value']);
  return _react2.default.createElement(
    _text2.default,
    props,
    Currency.format({
      children: children,
      defaultSymbol: defaultSymbol,
      hideCents: hideCents,
      hideCommas: hideCommas,
      noSymbol: noSymbol,
      round: round,
      value: value
    })
  );
};

Currency.roundToSignificantFigures = function (value) {
  return value >= 100000 || value <= -100000 ? Math.round(value / 1000) * 1000 : Math.round(value);
};

Currency.getValue = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var value = props.value,
      children = props.children,
      hideCents = props.hideCents,
      round = props.round;


  var property = value !== null && !isNaN(value) ? value : children;
  var displayValue = parseFloat(property);
  if (isNaN(displayValue)) {
    return null;
  }

  var roundedValue = hideCents ? displayValue.toFixed(0) : displayValue.toFixed(2);
  var result = round ? Currency.roundToSignificantFigures(roundedValue) : roundedValue;
  return result;
};

Currency.format = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hideCommas = props.hideCommas,
      defaultSymbol = props.defaultSymbol,
      noSymbol = props.noSymbol;

  var symbol = defaultSymbol || Currency.defaultProps.defaultSymbol;
  var roundedValue = Currency.getValue(props) || '';

  var formattedValue = noSymbol ? roundedValue : symbol + roundedValue;

  return hideCommas ? formattedValue : formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

Currency.propTypes = {
  children: _propTypes2.default.node,
  defaultSymbol: _propTypes2.default.string,
  hideCents: _propTypes2.default.bool,
  hideCommas: _propTypes2.default.bool,
  noSymbol: _propTypes2.default.bool,
  round: _propTypes2.default.bool,
  value: _propTypes2.default.number
};

Currency.defaultProps = {
  children: null,
  defaultSymbol: '$',
  hideCents: false,
  hideCommas: false,
  noSymbol: false,
  round: false,
  value: null
};

Currency.displayName = 'Currency';
Currency.huiName = 'hui:Currency';

exports.default = Currency;
//# sourceMappingURL=Currency.js.map


//////////////////
// WEBPACK FOOTER
// ../currency/lib/Currency.js
// module id = 690
// module chunks = 0